<template>
    <div>
      <ul class="info-list">
        <li
          v-for="info in infos"
          :key="info.id"
          class="info-item"
        >
          <span @click="openPdf(info)" class="info-name">{{ info.name }}</span>
          <div class="action-buttons">
            <button class="btn-edit" @click.stop="editInfo(info)">Modifier</button>
            <button class="btn-delete" @click.stop="deleteInfo(info)">Supprimer</button>
          </div>
        </li>
      </ul>
  
      <div
        v-if="showPdfModal"
        class="modal-overlay"
        @click.self="closeModal"
      >
        <div class="modal" ref="pdfModal">
          <button class="close-btn" @click="closeModal">×</button>
          <iframe
            :src="pdfSrc"
            width="100%"
            height="600px"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'EditComponent.vue',
    data() {
      return {
        selectedInfo: null,
        showPdfModal: false
      };
    },
    created() {
      this.$store.dispatch('loadInfos');
    },
    computed: {
      ...mapGetters(['getInfos']),
      infos() {
        return this.getInfos;
      },
      pdfSrc() {
        if (!this.selectedInfo) return '';
        const file = this.selectedInfo.file;
        return file.startsWith('data:application/pdf')
          ? file
          : `data:application/pdf;base64,${file}`;
      }
    },
    methods: {
      openPdf(info) {
        this.selectedInfo = info;
        this.showPdfModal = true;
        this.$nextTick(() => this.$refs.pdfModal.scrollTop = 0);
      },
      closeModal() {
        this.showPdfModal = false;
        this.selectedInfo = null;
      },
      editInfo(info) {
        this.$emit('edit', info);
      },
      deleteInfo(info) {
        this.$emit('delete', info);
      }
    }
  };
  </script>
  
  <style scoped>
  .info-list {
    list-style: none;
    padding: 0;
    margin: 1rem auto;
    max-width: 800px;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #eee;
    background-color: white;
    transition: transform 0.2s, background-color 0.2s;
    cursor: pointer;
    transform-origin: center;
  }
  .info-item:hover {
    background-color: #f9f9f9;
    transform: scale(1.03);
  }
  .info-item:last-child {
    border-bottom: none;
  }
  
  .info-name {
    flex: 1;
    color: #1E1C66;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .action-buttons {
    display: flex;
    gap: 0.5rem;
  }
  
  .btn-edit,
  .btn-delete {
    border: none;
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .btn-edit {
    background-color: #167580;
    color: #fff;
  }
  .btn-edit:hover {
    background-color: #145a62;
  }
  
  .btn-delete {
    background-color: #B82828;
    color: #fff;
  }
  .btn-delete:hover {
    background-color: #9e1f1f;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .modal {
    background: #fff;
    border-radius: 10px;
    padding: 2rem;
    width: 90%;
    max-width: 700px;
    max-height: 85vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  }
  .close-btn {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #1E1C66;
  }
  </style>
  